module.exports = __webpack_public_path__ + "static/media/15.1.35d683e9.png";